import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const Mac = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="51"
          height="48"
          viewBox="0 0 51 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.7249 35.6239H5.20056C2.34025 35.6239 0 33.2836 0 30.4233V5.20056C0 2.34025 2.34025 0 5.20056 0H44.9849C47.8452 0 50.1854 2.34025 50.1854 5.20056V30.6833C49.9254 33.2836 47.5852 35.6239 44.7249 35.6239Z"
            fill="url(#mac_linear)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.5241 12.696C23.7588 12.696 22.5664 11.8047 21.3274 11.8047C19.6801 11.8047 18.1728 12.8115 17.3234 14.2885C15.6154 17.2542 16.8836 21.6362 18.5496 24.0465C19.3674 25.2202 20.3311 26.5408 21.6098 26.4988C22.8359 26.4463 23.2968 25.702 24.7854 25.702C26.2636 25.702 26.6824 26.4988 27.9821 26.4673C29.3028 26.4463 30.1416 25.2727 30.9478 24.0885C31.8811 22.7258 32.2684 21.4052 32.2894 21.3317C32.2579 21.3212 29.7216 20.347 29.6901 17.4117C29.6691 14.9593 31.6921 13.7857 31.7866 13.7332C30.6339 12.0462 28.8629 11.8572 28.2446 11.8152C26.6299 11.6892 25.2789 12.696 24.5241 12.696V12.696Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.759 6.61345C26.7728 6.236 27.436 6.7925 27.2402 7.85643C27.0445 8.92035 26.064 10.0888 25.0502 10.4663C24.0364 10.8437 23.3732 10.2872 23.5689 9.22327C23.7647 8.15934 24.7452 6.99089 25.759 6.61345"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.0603 45.4642C18.563 45.4642 12.0983 46.299 7.2208 47.9249C6.45871 48.1789 5.63498 47.767 5.38094 47.0049C5.12691 46.2429 5.53878 45.4191 6.30087 45.1651C11.5645 43.4106 18.3612 42.5552 25.0603 42.5552C31.7576 42.5552 38.4948 43.4101 43.6356 45.1688C44.3957 45.4288 44.801 46.2557 44.541 47.0158C44.281 47.7759 43.454 48.1812 42.694 47.9212C37.9537 46.2995 31.5595 45.4642 25.0603 45.4642Z"
            fill="#565656"
          />
          <defs>
            <linearGradient
              id="mac_linear"
              x1="25.0927"
              y1="0"
              x2="25.0927"
              y2="35.6239"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D3D3D3" />
              <stop offset="1" stopColor="#676767" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default Mac;
